// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"178":"9ff889b19570dd82","636":"727973242bb33abd"}[chunkId] + ".css";
};